class PfPackSelector extends HTMLElement {
  #controller = new AbortController();

  connectedCallback() {
    this.selectedPack = this.querySelector('.selected_pack');
    this.packs = this.querySelectorAll('.pack_list .pack');
    this.quantityInput = document.querySelector(
      ".product-info__quantity-selector .quantity-selector input[name='quantity']"
    );

    const { signal } = this.#controller;

    this.selectedPack.addEventListener("click", () => {
      this.classList.toggle("active");
    }, { signal });

    this.packs.forEach((pack) => {
      pack.addEventListener('click', () => {
        const title = pack.getAttribute('data-title');
        const price = pack.getAttribute('data-price');
        const quantity = pack.getAttribute('data-quantity');

        this.selectedPack.querySelector('.title').innerText = title;
        this.selectedPack.querySelector('.price').innerText = price;
        this.quantityInput.value = quantity;

        this.classList.toggle('active');
      }, { signal });
    });
  }

  disconnectedCallback() {
    this.#controller.abort();
  }
}

if(!customElements.get("pf-pack-selector")) {
  customElements.define("pf-pack-selector", PfPackSelector);
}